/**
 * AD Control Bar
 */

import { h } from "preact";
import Toggle from "../../shared/components/Toggle";
import * as css from "./ADControls.module.scss";

const ADControls = ({
  toggled,
  onToggle,
}: {
  toggled: boolean;
  onToggle: (val: boolean) => void;
}) => {
  return (
    <form class={css.controls}>
      <Toggle
        id="enable-ad"
        toggled={toggled}
        onToggle={onToggle}
        iconType={"ad"}
        srLabel={toggled ? "Audio Description On" : "Audio Description Off"}
      />
    </form>
  );
};
export default ADControls;
